import { isArray, uniqBy } from 'lodash';

import FILTERS_LIST from 'src/components/Filters';

export const getFiltersName = (filters) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let result: any[] = [];

  filters.forEach(([name, value]) => {
    FILTERS_LIST.forEach((filter) => {
      const { filterName, filterLabel, valuesLabel, FILTER_NAMES } = filter;

      /** составной фильтр */
      if (FILTER_NAMES && FILTER_NAMES[name]) {
        result.push({
          filterName: name,
          filterGroupLabel: filterLabel,
          filterValue: FILTER_NAMES[name],
          diff: { id: true, selected: false },
        });
      }

      if (filterName === name) {
        if (name === 'prices') {
          result.push({
            filterName: name,
            filterGroupLabel: filterLabel,
            filterValue: valuesLabel(value),
            diff: { minPrice: undefined, maxPrice: undefined },
          });
        }

        if (name === 'hotel_name' && value?.value) {
          result.push({
            filterName: name,
            filterGroupLabel: filterLabel,
            filterValue: value.value,
            diff: { value: '' },
          });
        }

        if (
          name === 'distance_to_city_center' &&
          value?.selected_max_distance
        ) {
          result.push({
            filterName: name,
            filterGroupLabel: filterLabel,
            filterValue: valuesLabel(value),
            diff: { value: '' },
          });
        }

        const selectedValues = isArray(value)
          ? value.filter((item) => item.selected)
          : [];

        selectedValues.forEach((selectedValue) => {
          result.push({
            filterName: name,
            filterGroupLabel: filterLabel,
            filterValue: valuesLabel
              ? valuesLabel([selectedValue])
              : selectedValue.name ?? filterLabel,
            diff: { ...selectedValue, selected: false },
          });
        });

        // TODO: убрать костыль - в фильтре wifi отображается для выбора 3 опции, но по факту для бэкенда их 5
        if (name === 'wifi') {
          result = uniqBy(result, (el) => el.filterValue);
        }
      }
    });
  });

  return result;
};
